// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__m5nuI","imageUploader":"EGiftCard_imageUploader__2WkCA"};